module.exports = __webpack_public_path__ + "static/media/radio zofka@2x.8ae3873c.png";